var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"base",class:{ layout: _vm.flexlayout },style:({
    width: _vm.width + 'px',
    background: _vm.background,
    color: _vm.color,
    border: _vm.border,
  }),on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }